import { h } from "preact";

import { renderHtml, templateReplace } from "../helpers.js";
import i18n from "../i18n.js";

import Button from "./Button.jsx";
import CircleLoadingIndicator from "./CircleLoadingIndicator.jsx";
import HintCard from "./HintCard.jsx";

export default function Hint({ currentHintState, disabled, hint, onAction }) {
  const buttons = [];
  let button = null;

  if (!hint) {
    return null;
  }

  switch (currentHintState) {
    case "done":
      button = (
        <Button disabled iconFront="check">
          {i18n.t(`hints.${hint.id}.action_done`)}
        </Button>
      );
      break;
    case "sending":
      button = (
        <Button disabled iconFront={<CircleLoadingIndicator />}>
          {i18n.t(`hints.${hint.id}.action_doing`)}
        </Button>
      );
      break;
    default:
      button = (
        <Button disabled={disabled} onClick={() => onAction(hint.action)}>
          {i18n.t(`hints.${hint.id}.action_text`)}
        </Button>
      );
  }

  if (hint.action) {
    buttons.push(button);
  }
  if (hint.secondaryAction) {
    buttons.push(
      <Button
        class="mr-8"
        secondary
        onClick={() => onAction(hint.secondaryAction)}
        disabled={disabled}
      >
        {i18n.t(`hints.${hint.id}.secondary_action_text`)}
      </Button>
    );
  }

  const title = templateReplace(
    i18n.t(`hints.${hint.id}.title`, ""),
    hint.placeholders || {}
  );
  const description = templateReplace(
    i18n.t(`hints.${hint.id}.description`, ""),
    hint.placeholders || {}
  );

  return (
    <HintCard
      taskPage
      title={title}
      buttons={buttons.length > 0 && buttons}
      color={hint.color}
      icon={hint.icon}
    >
      {renderHtml(description)}
    </HintCard>
  );
}
